import React from "react";

export default function renderIcon({
  width = 21,
  height = 21,
  color = "#9ca2b8",
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 10.8734C22.5 6.11844 17.7899 2.25 11.9999 2.25C6.2107 2.25 1.5 6.11844 1.5 10.8734C1.5 15.1363 5.23547 18.7063 10.2813 19.3814C10.6233 19.4559 11.0887 19.6095 11.2064 19.9053C11.3123 20.174 11.2757 20.5949 11.2403 20.8662C11.2403 20.8662 11.117 21.6161 11.0905 21.7757C11.0448 22.0445 10.8796 22.8265 11.9999 22.3486C13.1207 21.8707 18.0469 18.7451 20.2498 16.179C21.7715 14.4903 22.5 12.7765 22.5 10.8734Z"
        fill="#2CCF54"
      />
      <path
        d="M9.86696 8.56836H9.13046C9.01758 8.56836 8.92578 8.66091 8.92578 8.77468V13.3996C8.92578 13.5135 9.01758 13.6059 9.13046 13.6059H9.86696C9.97991 13.6059 10.0715 13.5135 10.0715 13.3996V8.77468C10.0715 8.66091 9.97991 8.56836 9.86696 8.56836Z"
        fill="white"
      />
      <path
        d="M14.936 8.56836H14.1995C14.0866 8.56836 13.995 8.66091 13.995 8.77468V11.5224L11.8984 8.66008C11.8596 8.60128 11.7968 8.57218 11.7281 8.56836H10.9919C10.8789 8.56836 10.7871 8.66091 10.7871 8.77468V13.3996C10.7871 13.5135 10.8789 13.6059 10.9919 13.6059H11.7281C11.8412 13.6059 11.9328 13.5135 11.9328 13.3996V10.6527L14.0321 13.5186C14.0698 13.5726 14.1338 13.6059 14.1995 13.6059H14.936C15.0491 13.6059 15.1406 13.5135 15.1406 13.3996V8.77468C15.1406 8.66091 15.0491 8.56836 14.936 8.56836Z"
        fill="white"
      />
      <path
        d="M8.09203 12.4475H6.09083V8.77465C6.09083 8.6605 5.99925 8.56787 5.88653 8.56787H5.14982C5.0369 8.56787 4.94531 8.6605 4.94531 8.77465V13.3987C4.94531 13.511 5.0365 13.6056 5.14962 13.6056H8.09203C8.20491 13.6056 8.29611 13.5128 8.29611 13.3987V12.6542C8.29611 12.54 8.20491 12.4475 8.09203 12.4475Z"
        fill="white"
      />
      <path
        d="M19.0022 9.72602C19.1151 9.72602 19.2063 9.6337 19.2063 9.51932V8.7748C19.2063 8.66065 19.1151 8.56787 19.0022 8.56787H16.06C15.947 8.56787 15.8555 8.66237 15.8555 8.77465V13.3989C15.8555 13.5108 15.9467 13.6056 16.0595 13.6056H19.0022C19.1151 13.6056 19.2063 13.5128 19.2063 13.3989V12.6542C19.2063 12.5402 19.1151 12.4475 19.0022 12.4475H17.0012V11.6657H19.0022C19.1151 11.6657 19.2063 11.5731 19.2063 11.459V10.7145C19.2063 10.6004 19.1151 10.5076 19.0022 10.5076H17.0012V9.72602H19.0022Z"
        fill="white"
      />
    </svg>
  );
}
